import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Bed } from 'assets/images/bed.svg';

export const HotelWrapper = styled.div`
  display: flex;
  margin: 8px 0 0;
`;

export const BedIcon = styled(Bed)`
  width: 16px;
  height: 16px;
  margin-top: 4px;
  margin-right: 10px;
`;

export const HotelName = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;
